import "bootstrap-icons/font/bootstrap-icons.css";
import { Jumbotron } from "sections";

function PrivacyPolicy() {
  return (
    <div>
      <section className="section jumbotron">
        <Jumbotron
          badgeText="Privacy Policy"
          title={`      
            <span className="jumbotron-subtitle-2">
              Privacy
            </span>Policy`}
        />
      </section>

      <section className="section about container">
        <div className="row" style={{ justifyContent: "center" }}>
          <div className="col-xl-3">
            <h3>About</h3>
          </div>
          <div className="col-xl-7">
            <p>
              At alrajhi bank Malaysia, we recognize that keeping our customers’
              personal and financial information secure is our top priority as
              customers’ trust is our most valuable asset. This statement is
              issued to assure you of our commitment to the Privacy Policy:
            </p>

            <div className="row g-3">
              <div className="col-12 custom-column-2">
                <div className="column-header-2">
                  Collection of Information{" "}
                </div>
                <div className="column-subheader-2">
                  You will be required to provide us with various types of
                  personal information such as your name, identity card number,
                  address, age, gender, mobile number / phone number. Where
                  necessary other financial information such as your income,
                  assets and liabilities and other information may be required
                  as well when applying for our product and services or
                  performing any internet banking with us.
                </div>
              </div>
              <div className="col-12 custom-column-2">
                <div className="column-header-2">
                  Use and Sharing of Information{" "}
                </div>
                <div className="column-subheader-2">
                  We will limit the information gathered to provide you with
                  superior service and offer you any additional product and
                  services that will be beneficial to you.<br></br>
                  <br></br>
                  We will not disclose customers’ information to any external
                  parties unless have been authorized by customers, we have
                  beforehand informed customers in disclosures or agreements or
                  required by law.However, we may from time to time accept
                  partnership from reputable companies to offer you wider
                  opportunities and offer to benefit you. However, we will
                  ensure that these companies conform to the same customer
                  privacy standards. <br></br>
                  <br></br>If you opt to remove your name from our distribution
                  of information listing, at any time, please email or send your
                  request to @alrajhibank.com.my
                </div>
              </div>
              <div className="col-12 custom-column-2">
                <div className="column-header-2">Employee Access</div>
                <div className="column-subheader-2">
                  Employee access is permitted to only authorized employee who
                  is fully trained in proper handling of customer information
                  and is required to ensure the confidentiality of customers’
                  information all the time. Employees who have access to
                  customers’ information will be subject to disciplinary action
                  in compliance to the Islamic Financial Services Act 2013,
                  should they violate this privacy policy. 
                </div>
              </div>
              <div className="col-12 custom-column-2">
                <div className="column-header-2">
                  Security Measures Used to Protect Customers Information
                </div>
                <div className="column-subheader-2">
                  We shall strive to ensure high computer security standards and
                  procedures to ensure all customers’ transactions and
                  information are secured and confidential all the time. Our
                  security measures put in place are subject to risk analyses,
                  and procedures are regularly tested and updated to ensure that
                  information received from customers through the internet is
                  safe and secure.
                </div>
              </div>
              <div className="col-12 custom-column-2">
                <div className="column-header-2">Accuracy of Information</div>
                <div className="column-subheader-2">
                  We will ensure that customers’ data and information is
                  complete, up-to-date and accurate. However, you are advised to
                  inform us promptly and accurately of any changes by writing to
                  us. Your records will  be promptly updated upon receiving of
                  such information from you.
                </div>
              </div>
              <div className="col-12 custom-column-2">
                <div className="column-header-2">
                  Customer Enquiries and Complaints
                </div>
                <div className="column-subheader-2">
                  You may direct any enquiries or complaints relating to your
                  information by writing or e-mailing us at: 
                  customersupport@alrajhibank.com.my
                </div>
              </div>
              <div className="col-12 custom-column-2">
                <div className="column-header-2">
                  Customer Correspondence Unit
                </div>
                <div className="column-subheader-2">
                  Ground Floor, East Block,<br></br>Wisma Golden Eagle Realty
                  <br></br>142-B Jalan Ampang<br></br>50450 Kuala Lumpur
                  <br></br>Email: customersupport@alrajhibank.com.my
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default PrivacyPolicy;
